import { createSlice, current } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios, endpoint } from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  posts: [],
  kelasByJenjang: [],
  fase: [],
  index: 0,
};

const slice = createSlice({
  name: 'kelas',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET KELAS
    getKelasSuccess(state, action) {
      state.isLoading = false;
      state.posts = action.payload;
    },

    // GET KELAS by JENJANG
    getKelasByJenjangSuccess(state, action) {
      const stateKelas = current(state);
      let dataKelas = stateKelas.posts;
      dataKelas = dataKelas.filter(
        (item) => item.jenjang_id === action.payload.school_id,
      );
      state.isLoading = false;
      state.kelasByJenjang = dataKelas;
    },

    // GET FASE
    getFaseSuccess(state, action) {
      state.isLoading = false;
      state.fase = action.payload;
    },

    // RESET STATE
    reset() {
      return initialState;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { getKelasSuccess } = slice.actions;

// ----------------------------------------------------------------------

export function getAllKelas() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(endpoint.kelasSp.root);
      dispatch(slice.actions.getKelasSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getKelasByJenjang(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.getKelasByJenjangSuccess(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getKelasFase() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(endpoint.kelasSp.fase);
      dispatch(slice.actions.getFaseSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function resetAllKelas() {
  return async (dispatch) => {
    dispatch(slice.actions.reset);
  };
}
